/* eslint-disable max-lines-per-function, max-lines, max-len */
import ExcelJS from "exceljs";
import { isNil } from "lodash";
import { EMPTY_VALUE } from "../../../constants/common";
import { LOCATIONS_COMPARE_PARAM_RENDERS } from "../../../constants/filters";
import { downloadExcelFile, formatDate } from "../../../utils";
const MARKET_NICHE_KEY = "Рыночная ниша";
const SECTION_COLORS = {
    "Рыночная ниша": {
        headColor: "ddefff",
        bodyColor: "edf7fe",
    },
    "Потребители": {
        headColor: "d3f4f9",
        bodyColor: "e9fafc",
    },
    "Недвижимость": {
        headColor: "e2faf1",
        bodyColor: "f0fcf8",
    },
    "Генераторы потока": {
        headColor: "ebfedc",
        bodyColor: "f5ffed",
    },
    "Транспортная инфраструктура": {
        headColor: "fdf3da",
        bodyColor: "fef9ec",
    },
};
const REFERENCE_ITEMS = {
    "Рыночная ниша": [
        {
            id: 1,
            title: "Размер рыночной ниши (нереализованный спрос)",
            unit: "тыс. руб./год",
            description: "Часть платежеспособного спроса потребителей, которая может быть реализована новой торговой/сервисной точкой с учетом конкурентного окружения. Под потребителями понимаются потенциальные клиенты новой торговой/сервисной точки, находящиеся в рамках зоны ее обслуживания, определяемой спецификой бизнеса",
        },
        {
            id: 2,
            title: "Конкуренты",
            unit: "ед.",
            description: "Торговые/сервисные точки, предлагающие полностью или частично схожий  ассортимент товаров и услуг потенциальным потребителям новой торговой/сервисной точки",
        },
        {
            id: 3,
            title: "Средний чек жителей",
            unit: "руб.",
            description: "Сумма чеков клиентов данного вида бизнеса за год среди населения, проживающего в зоне обсуживания новой торговой/сервисной точки, деленная на их количество. Показатель определяется на основе агрегированных данных Федеральной налоговой службы РФ о тратах населения, а также на основе исследований, проведенных по заказу Корпорации МСП",
        },
        {
            id: 4,
            title: "Доля покупателей среди жителей",
            unit: "%",
            description: "Количество клиентов данного вида бизнеса среди жителей, отнесенное к общему количеству населения, проживающему в зоне обслуживания новой торговой/сервисной точки. Показатель определяется на основе агрегированных данных Федеральной налоговой службы РФ о тратах населения, а также на основе исследований, проведенных по заказу Корпорации МСП",
        },
        {
            id: 5,
            title: "Средний чек офисных служащих",
            unit: "руб.",
            description: "Сумма чеков клиентов данного вида бизнеса за год среди офисных служащих, работающих в зоне обсуживания новой торговой/сервисной точки, деленная на их количество. Показатель определяется на основе агрегированных данных Федеральной налоговой службы РФ о тратах населения, а также на основе исследований, проведенных по заказу Корпорации МСП",
        },
        {
            id: 6,
            title: "Доля покупателей среди офисных служащих",
            unit: "%",
            description: "Количество клиентов данного вида бизнеса среди офисных служащих, отнесенное к общему количеству офисных служащих, работающих в зоне обслуживания новой торговой/сервисной точки. Показатель определяется на основе агрегированных данных Федеральной налоговой службы РФ о тратах населения, а также на основе исследований, проведенных по заказу Корпорации МСП",
        },
    ],
    "Потребители": [
        {
            id: 7,
            title: "Домохозяйства",
            unit: "ед.",
            description: "Количество частных домов и квартир в многоквартирных домах, расположенных в зоне обслуживания новой торговой/сервисной точки. Показатель определяется на основе базы геоданных 2ГИС",
        },
        {
            id: 8,
            title: "Жители",
            unit: "чел.",
            description: "Количество жителей, проживающих в многоквартирных и частных домах, расположенных в зоне обслуживания новой торговой/сервисной точки. Показатель определяется на основе базы геоданных 2ГИС и официальной статистики Росстата",
        },
        {
            id: 9,
            title: "Офисные служащие",
            unit: "чел.",
            description: "Количество офисных служащих, работающих в бизнес-центрах, расположенных в зоне обслуживания новой торговой/сервисной точки. Показатель определяется на основе базы геоданных 2ГИС, а также на основе исследований, проведенных по заказу Корпорации МСП",
        },
        {
            id: 10,
            title: "Средний доход потребителей",
            unit: "руб./чел. в месяц",
            description: "Среднедушевой доход жителей и офисных служащих, проживающих и работающих в зоне обслуживания новой торговой/сервисной точки. Рассчитывается как средневзвешенное значение уровня доходов по 4-м доходным группам: высокодоходные, среднеобеспеченные, малообеспеченные, низкодоходные. В качестве веса используется оценка количества потребителей в каждой доходной группе, определяемая на основе данных официальной статистики Росстата, а также на основе исследований, проведенных по заказу Корпорации МСП, с учетом ряда отражающих доход показателей, таких как доход на одного члена семьи, самоопределение материального положения, доля трат на еду и ЖКХ",
        },
    ],
    "Недвижимость": [
        {
            id: 11,
            title: "Многоквартирные дома",
            unit: "ед.",
            description: "Количество многоквартирных жилых зданий, расположенных в зоне обслуживания новой торговой/сервисной точки. Показатель определяется на основе базы геоданных 2ГИС",
        },
        {
            id: 12,
            title: "Новостройки в течении 3-х лет",
            unit: "ед.",
            description: "Количество многоквартирных жилых зданий, расположенных в зоне обслуживания новой торговой/сервисной точки, которые строятся в настоящее время или будут построены в ближайшие 3 года согласно данным Единой информационной системы жилищного  строительства (ЕИСЖС)",
        },
        {
            id: 13,
            title: "Частные дома",
            unit: "ед.",
            description: "Количество частных домов (малоэтажных домостроений), расположенных в зоне обслуживания новой торговой/сервисной точки. Показатель определяется на основе базы геоданных 2ГИС",
        },
        {
            id: 14,
            title: "Офисные здания",
            unit: "ед.",
            description: "Количество офисных зданий и бизнес-центров, расположенных в зоне обслуживания новой торговой/сервисной точки. Показатель определяется на основе базы геоданных 2ГИС",
        },
        {
            id: 15,
            title: "Средневзвешенная стоимость жилой недвижимости",
            unit: "тыс. руб./кв. м",
            description: "Средневзвешенное значение цены покупки 1 кв. метра жилой недвижимости во всех домах, попавших в зону обслуживания новой торговой/сервисной точки. В качестве веса  используется оценка количества квартир в доме.  Показатель рассчитывается на основе базы геоданных 2ГИС, а также на основе данных исследований, проведенных по заказу Корпорации МСП",
        },
    ],
    "Генераторы потока": [
        {
            id: 16,
            title: "ТЦ / ТРЦ",
            unit: "ед.",
            description: "Количество торговых и торгово-развлекательных центров (генераторов потока местных жителей), расположенных в зоне обслуживания новой торговой/сервисной точки",
        },
        {
            id: 17,
            title: "Достопримечательности",
            unit: "ед.",
            description: "Количество крупных культурных, спортивных, транспортных, социальных и туристических объектов (генераторов потока приезжих), расположенных в зоне обслуживания новой торговой/сервисной точки",
        },
    ],
    "Транспортная инфраструктура": [
        {
            id: 18,
            title: "Остановки",
            unit: "ед.",
            description: "Количество остановок общественного транспорта в пешей доступности (350 метров вокруг новой торговой/сервисной точки)",
        },
        {
            id: 19,
            title: "Станции метро",
            unit: "ед.",
            description: "Количество станций метрополитена, расположенных в пешей доступности (350 метров вокруг новой торговой/сервисной точки)",
        },
        {
            id: 20,
            title: "Парковочные машиноместа",
            unit: "ед.",
            description: "Количество парковочных машиномест, расположенных в пешей доступности (350 метров вокруг новой торговой/сервисной точки)",
        },
    ],
};
export const generateExcel = (fileName, businessConcept, locations, params) => {
    if (!businessConcept || !locations) {
        return;
    }
    const filteredParams = Object.entries(params).reduce((acc, [key, value]) => {
        const visibleParams = value.filter(item => item.visible);
        if (visibleParams.length === 0) {
            return acc;
        }
        return {
            ...acc,
            [key]: visibleParams,
        };
    }, {});
    const workbook = new ExcelJS.Workbook();
    const logoImageId = workbook.addImage({
        base64: "data:image/jpeg;base64,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\n",
        extension: "jpeg",
    });
    const lineImageId = workbook.addImage({
        base64: "data:image/png;base64,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\n",
        extension: "png",
    });
    /* *********************************** */
    /*                                     */
    /*           ПЕРВАЯ ВКЛАДКА            */
    /*                                     */
    /* *********************************** */
    const HEADER_HEIGHT = 5;
    const sheet = workbook.addWorksheet("Отчет о сравнении точек", {
        views: [{
                state: "frozen",
                xSplit: 2,
                ySplit: HEADER_HEIGHT + 3,
            }],
        properties: {
            defaultColWidth: 8,
            defaultRowHeight: 14,
        },
    });
    sheet.columns = [];
    const sheetColumnsWidth = [5, 65, 21, 21, 21, 21, 21];
    sheetColumnsWidth.forEach((width, index) => {
        sheet.getColumn(index + 1).width = width;
    });
    // Заголовок
    sheet.mergeCells("A1:B2");
    sheet.mergeCells("A3:B3");
    sheet.getCell("B3").value = "  Дата формирования отчета:";
    sheet.getCell("C3").value = `${formatDate(new Date())}`;
    sheet.mergeCells("A4:B4");
    sheet.getCell("B4").value = "  Наименование вида бизнеса:";
    sheet.getCell("C4").value = businessConcept.name;
    sheet.getCell("E1").value = "8-800-100-1-100";
    sheet.getCell("G1").value = "мсп.рф";
    sheet.mergeCells("C1:D2");
    sheet.mergeCells("E2:G2");
    sheet.addImage(logoImageId, {
        tl: { col: 1, row: 0.9 },
        ext: { width: 400, height: 45 },
    });
    sheet.addImage(lineImageId, {
        tl: { col: 4, row: 1 },
        ext: { width: 500, height: 28 },
    });
    sheet.getCell("A1").style = {
        alignment: { horizontal: "center", vertical: "middle" },
        fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffffff" },
        },
    };
    sheet.getCell("C1").style = {
        alignment: { horizontal: "center", vertical: "middle" },
        fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffffff" },
        },
    };
    sheet.getCell("E1").style = {
        alignment: { horizontal: "center", vertical: "middle" },
        fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffffff" },
        },
    };
    sheet.getCell("F1").style = {
        alignment: { horizontal: "center", vertical: "middle" },
        fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffffff" },
        },
    };
    sheet.getCell("G1").style = {
        alignment: { horizontal: "center", vertical: "middle" },
        fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffffff" },
        },
    };
    sheet.getCell("E2").style = {
        alignment: { horizontal: "center", vertical: "middle" },
        fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffffff" },
        },
    };
    sheet.getRow(1).height = 35;
    sheet.getRow(2).height = 20;
    // Стили заголовка
    for (let i = 3; i <= 4; i += 1) {
        sheet.getCell(`A${i}`).style = {
            font: {
                name: "Arial",
                size: 10,
                color: { argb: "808080" },
            },
            alignment: { vertical: "middle" },
        };
        sheet.mergeCells(`C${i}:G${i}`);
        sheet.getCell(`C${i}`).style = {
            font: {
                name: "Arial",
                size: i < 4 ? 10 : 11,
                color: i === 3
                    ? { argb: "9c87f1" }
                    : undefined,
            },
            alignment: { vertical: "middle" },
        };
    }
    sheet.mergeCells("A5:G5");
    const locationHeadRowNum = HEADER_HEIGHT + 1;
    const locationHeadRow = sheet.getRow(locationHeadRowNum);
    const addressRow = sheet.getRow(HEADER_HEIGHT + 2);
    const marketNicheRowNum = HEADER_HEIGHT + 3;
    const marketNicheRow = sheet.getRow(marketNicheRowNum);
    sheet.mergeCells(`A${locationHeadRowNum}:B${locationHeadRowNum + 1}`);
    locationHeadRow.getCell(1).value = "Номер и адрес точки";
    locationHeadRow.getCell(1).style = {
        font: {
            name: "Arial",
            size: 10,
            color: { argb: "808080" },
        },
        alignment: { horizontal: "center", vertical: "middle" },
        fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "f1efff" },
        },
        border: {
            right: { style: "thin", color: { argb: "d4d4d4" } },
            left: { style: "thin", color: { argb: "d4d4d4" } },
            top: { style: "thin", color: { argb: "d4d4d4" } },
            bottom: { style: "thin", color: { argb: "d4d4d4" } },
        },
    };
    locationHeadRow.getCell(2).style = {
        border: {
            right: { style: "thin", color: { argb: "d4d4d4" } },
            left: { style: "thin", color: { argb: "d4d4d4" } },
            top: { style: "thin", color: { argb: "d4d4d4" } },
            bottom: { style: "thin", color: { argb: "d4d4d4" } },
        },
    };
    // Таблица
    for (let i = 1; i <= 5; i += 1) {
        locationHeadRow.getCell(i + 2).value = `Точка ${i}`;
        locationHeadRow.eachCell((cell, cellIndex) => {
            if (cellIndex > 2) {
                cell.style = {
                    font: { name: "Arial", size: 10 },
                    alignment: { horizontal: "center", vertical: "middle" },
                    fill: {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "f1efff" },
                    },
                    border: {
                        right: { style: "thin", color: { argb: "d4d4d4" } },
                        left: { style: "thin", color: { argb: "d4d4d4" } },
                        top: { style: "thin", color: { argb: "d4d4d4" } },
                        bottom: { style: "thin", color: { argb: "d4d4d4" } },
                    },
                };
            }
        });
        addressRow.getCell(i + 2).value = locations[i - 1]?.details?.analytic?.address ?? EMPTY_VALUE;
        addressRow.height = 53;
        addressRow.eachCell(cell => {
            cell.style = {
                font: {
                    name: "Arial",
                    size: 10,
                    color: { argb: "808080" },
                },
                alignment: { horizontal: "center", vertical: "middle", wrapText: true },
                fill: {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "f1efff" },
                },
                border: {
                    right: { style: "thin", color: { argb: "d4d4d4" } },
                    left: { style: "thin", color: { argb: "d4d4d4" } },
                    top: { style: "thin", color: { argb: "d4d4d4" } },
                    bottom: { style: "thin", color: { argb: "d4d4d4" } },
                },
            };
        });
    }
    sheet.mergeCells(`A${marketNicheRowNum}:B${marketNicheRowNum}`);
    marketNicheRow.getCell(1).value = "Ценовая ниша";
    for (let i = 1; i <= 5; i += 1) {
        const currentLocation = locations[i - 1];
        const currentFormat = businessConcept.business_formats?.find(format => format.id === currentLocation?.formatId);
        marketNicheRow.getCell(i + 2).value = currentFormat?.name ?? EMPTY_VALUE;
    }
    marketNicheRow.eachCell(cell => {
        cell.style = {
            font: {
                name: "Arial",
                size: 10,
                color: { argb: "808080" },
            },
            alignment: { horizontal: "center", vertical: "middle" },
            fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "f5f7fe" },
            },
        };
    });
    let bodyRowsCount = 0;
    let paramCount = 0;
    Object.entries(filteredParams).forEach(([key, value]) => {
        bodyRowsCount += 1;
        const emptyRowNum = HEADER_HEIGHT + 3 + bodyRowsCount;
        const emptyRow = sheet.getRow(emptyRowNum);
        emptyRow.height = 13;
        sheet.mergeCells(`A${emptyRowNum}:G${emptyRowNum}`);
        bodyRowsCount += 1;
        const subtitleRowNum = HEADER_HEIGHT + 3 + bodyRowsCount;
        const subtitleRow = sheet.getRow(subtitleRowNum);
        subtitleRow.getCell(1).value = ` ${key}`;
        subtitleRow.height = 23;
        subtitleRow.getCell(1).style = {
            font: { name: "Arial", size: 11 },
            alignment: { vertical: "middle" },
            fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: SECTION_COLORS[key].headColor },
            },
        };
        sheet.mergeCells(`A${subtitleRowNum}:G${subtitleRowNum}`);
        if (key === MARKET_NICHE_KEY) {
            bodyRowsCount += 1;
            const freeNicheRowNum = HEADER_HEIGHT + 3 + bodyRowsCount;
            const freeNicheRow = sheet.getRow(freeNicheRowNum);
            paramCount += 1;
            freeNicheRow.getCell(1).value = paramCount;
            freeNicheRow.getCell(2).value = "  Свободная рыночная ниша, тыс. руб./год";
            for (let i = 1; i <= 5; i += 1) {
                const currentLocation = locations[i - 1];
                freeNicheRow.getCell(i + 2).value = currentLocation
                    ? +currentLocation.details?.statistic?.supply.values[1]?.value
                    : EMPTY_VALUE;
            }
            freeNicheRow.eachCell((cell, cellIndex) => {
                const paramRender = +locations[cellIndex - 3]?.details?.statistic?.supply.values[1]?.value;
                const isNumberParam = typeof paramRender === "number";
                const allRowRenders = locations.reduce((maxAcc, maxCurr) => ([
                    ...maxAcc,
                    maxCurr?.details?.statistic?.supply.values[1]?.value,
                ]), []);
                const isMax = isNumberParam
                    && locations.length > 1
                    && allRowRenders.filter(num => num === Math.max(...allRowRenders)).length === 1
                    && paramRender === Math.max(...allRowRenders);
                cell.style = {
                    font: {
                        name: "Arial",
                        size: 10,
                        color: isMax ? { argb: "9D87F1" } : undefined,
                        bold: isMax,
                    },
                    alignment: {
                        horizontal: cellIndex === 1
                            ? "center"
                            : cellIndex > 2
                                ? "right"
                                : undefined,
                        vertical: "middle",
                    },
                    fill: cellIndex > 2 ? {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: SECTION_COLORS[key].bodyColor },
                    } : undefined,
                    border: {
                        right: { style: "thin", color: { argb: "d4d4d4" } },
                        left: { style: "thin", color: { argb: "d4d4d4" } },
                        top: { style: "thin", color: { argb: "d4d4d4" } },
                        bottom: { style: "thin", color: { argb: "d4d4d4" } },
                    },
                };
                if (cellIndex > 2) {
                    cell.numFmt = "# ##0.0";
                }
            });
        }
        value.forEach(item => {
            bodyRowsCount += 1;
            const itemRowNum = HEADER_HEIGHT + 3 + bodyRowsCount;
            const itemRow = sheet.getRow(itemRowNum);
            paramCount += 1;
            itemRow.getCell(1).value = paramCount;
            itemRow.getCell(2).value = `  ${item.name || ""}`;
            itemRow.getCell(1).style = {
                font: { name: "Arial", size: 10 },
                alignment: { horizontal: "center", vertical: "middle" },
                border: {
                    right: { style: "thin", color: { argb: "d4d4d4" } },
                    left: { style: "thin", color: { argb: "d4d4d4" } },
                    top: { style: "thin", color: { argb: "d4d4d4" } },
                    bottom: { style: "thin", color: { argb: "d4d4d4" } },
                },
            };
            itemRow.getCell(2).style = {
                font: { name: "Arial", size: 10 },
                alignment: { vertical: "middle" },
                border: {
                    right: { style: "thin", color: { argb: "d4d4d4" } },
                    left: { style: "thin", color: { argb: "d4d4d4" } },
                    top: { style: "thin", color: { argb: "d4d4d4" } },
                    bottom: { style: "thin", color: { argb: "d4d4d4" } },
                },
            };
            for (let i = 1; i <= 5; i += 1) {
                const valueCell = itemRow.getCell(i + 2);
                const paramRender = LOCATIONS_COMPARE_PARAM_RENDERS[item.key]?.(locations[i - 1]?.details);
                const isNumberParam = typeof paramRender === "number";
                const allRowRenders = locations.reduce((maxAcc, maxCurr) => ([
                    ...maxAcc,
                    LOCATIONS_COMPARE_PARAM_RENDERS[item.key]?.(maxCurr.details),
                ]), []);
                const isMax = isNumberParam
                    && locations.length > 1
                    && allRowRenders.filter(num => num === Math.max(...allRowRenders)).length === 1
                    && paramRender === Math.max(...allRowRenders);
                valueCell.value = paramRender !== undefined
                    ? isNumberParam
                        ? isNil(paramRender) ? "Нет данных" : paramRender
                        : (paramRender ?? "Нет данных")
                    : EMPTY_VALUE;
                valueCell.style = {
                    font: {
                        name: "Arial",
                        size: 10,
                        color: isMax ? { argb: "9D87F1" } : undefined,
                        bold: isMax,
                    },
                    alignment: { horizontal: "right", vertical: "middle" },
                    fill: {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: SECTION_COLORS[key].bodyColor },
                    },
                    border: {
                        right: { style: "thin", color: { argb: "d4d4d4" } },
                        left: { style: "thin", color: { argb: "d4d4d4" } },
                        top: { style: "thin", color: { argb: "d4d4d4" } },
                        bottom: { style: "thin", color: { argb: "d4d4d4" } },
                    },
                };
                valueCell.numFmt = "# ##0.0";
            }
        });
    });
    bodyRowsCount += 1;
    const emptyRow2Num = HEADER_HEIGHT + 3 + bodyRowsCount;
    const emptyRow2 = sheet.getRow(emptyRow2Num);
    emptyRow2.height = 13;
    sheet.mergeCells(`A${emptyRow2Num}:G${emptyRow2Num}`);
    bodyRowsCount += 1;
    const footerLineRowNum = HEADER_HEIGHT + 3 + bodyRowsCount;
    const footerLineRow = sheet.getRow(footerLineRowNum);
    footerLineRow.height = 20;
    sheet.mergeCells(`A${footerLineRowNum}:G${footerLineRowNum}`);
    sheet.addImage(lineImageId, {
        tl: { col: 0, row: footerLineRowNum - 1 },
        ext: { width: 350, height: 28 },
    });
    bodyRowsCount += 1;
    const footerTextRowNum = HEADER_HEIGHT + 3 + bodyRowsCount;
    const footerTextRow = sheet.getRow(footerTextRowNum);
    footerTextRow.height = 30;
    sheet.mergeCells(`A${footerTextRowNum}:G${footerTextRowNum}`);
    footerTextRow.getCell(1).value = "Акционерное общество «Федеральная корпорация развития малого и среднего предпринимательства» действует в соответствии с Гражданским кодексом Российской Федерации, федеральным законом от 26.12.1995 No 208-ФЗ «Об акционерных обществах».";
    footerTextRow.getCell(1).style = {
        font: {
            name: "Arial",
            size: 10,
            color: { argb: "808080" },
        },
        alignment: { vertical: "middle", wrapText: true },
    };
    /* *********************************** */
    /*                                     */
    /*           ВТОРАЯ ВКЛАДКА            */
    /*                                     */
    /* *********************************** */
    const referenceSheet = workbook.addWorksheet("Справочно", {
        views: [{
                state: "frozen",
                xSplit: 2,
                ySplit: 3,
            }],
        properties: {
            defaultColWidth: 8,
            defaultRowHeight: 14,
        },
    });
    referenceSheet.columns = [];
    const referenceColumnsWidth = [5, 55, 20, 140];
    referenceColumnsWidth.forEach((width, index) => {
        referenceSheet.getColumn(index + 1).width = width;
    });
    referenceSheet.getRow(1).height = 8.5;
    referenceSheet.mergeCells("A2:D2");
    referenceSheet.getRow(2).height = 33.5;
    referenceSheet.getCell("A2").value = "Определения показателей, используемых для сравнения территорий вокруг новых торговых/сервисных точек";
    referenceSheet.getCell("A2").style = {
        font: {
            name: "Arial",
            size: 10,
            color: { argb: "808080" },
        },
        alignment: { horizontal: "center", vertical: "middle" },
        fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "f5f7fe" },
        },
    };
    referenceSheet.getRow(3).height = 21;
    referenceSheet.mergeCells("A3:B3");
    referenceSheet.getCell("A3").value = "Наименование";
    referenceSheet.getCell("C3").value = "Ед. измерения";
    referenceSheet.getCell("D3").value = "Определение";
    referenceSheet.getRow(3).eachCell(cell => {
        cell.style = {
            font: {
                name: "Arial",
                size: 10,
                color: { argb: "808080" },
            },
            alignment: { horizontal: "center", vertical: "middle" },
            border: {
                right: { style: "thin", color: { argb: "d4d4d4" } },
                left: { style: "thin", color: { argb: "d4d4d4" } },
                top: { style: "thin", color: { argb: "d4d4d4" } },
                bottom: { style: "thin", color: { argb: "d4d4d4" } },
            },
        };
    });
    referenceSheet.getRow(4).height = 82;
    referenceSheet.mergeCells("A4:B4");
    referenceSheet.getCell("A4").value = "  Ценовая ниша";
    referenceSheet.getCell("C4").value = {
        richText: [
            {
                font: { name: "Arial", size: 10 },
                text: "Премиум",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "\n",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "Массовая",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "\n",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "Эконом",
            },
        ],
    };
    referenceSheet.getCell("D4").value = {
        richText: [
            {
                font: { name: "Arial", size: 10 },
                text: "Уровень цен на товары и услуги, предлагаемые клиентам в торговой/сервисной точке.  Имеет качественное описание - премиум, массовая, эконом",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "\n",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "Премиум – торговые/сервисные точки с ценами выше среднерыночных, ориентированные на людей с высокими доходами",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "\n",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "Массовая – торговые/сервисные точки с ценами, приближенными к среднерыночным, ориентированные на людей со средними доходами",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "\n",
            },
            {
                font: { name: "Arial", size: 10 },
                text: "Эконом – торговые/сервисные точки с ценами ниже среднерыночных, ориентированные на людей с низкими доходами",
            },
        ],
    };
    referenceSheet.getRow(4).eachCell((cell, cellIndex) => {
        cell.style = {
            font: {
                name: "Arial",
                size: 10,
            },
            alignment: { horizontal: cellIndex === 3 ? "center" : "left", vertical: "middle", wrapText: true },
            border: {
                right: { style: "thin", color: { argb: "d4d4d4" } },
                left: { style: "thin", color: { argb: "d4d4d4" } },
                top: { style: "thin", color: { argb: "d4d4d4" } },
                bottom: { style: "thin", color: { argb: "d4d4d4" } },
            },
        };
    });
    const HEADER_2_HEIGHT = 4;
    let referenceBodyRowsCount = 0;
    Object.entries(REFERENCE_ITEMS).forEach(([key, values]) => {
        referenceBodyRowsCount += 1;
        referenceSheet.getRow(HEADER_2_HEIGHT + referenceBodyRowsCount).height = 7.5;
        referenceSheet.mergeCells(`A${HEADER_2_HEIGHT + referenceBodyRowsCount}:D${HEADER_2_HEIGHT + referenceBodyRowsCount}`);
        referenceBodyRowsCount += 1;
        referenceSheet.getRow(HEADER_2_HEIGHT + referenceBodyRowsCount).height = 23;
        referenceSheet.mergeCells(`A${HEADER_2_HEIGHT + referenceBodyRowsCount}:D${HEADER_2_HEIGHT + referenceBodyRowsCount}`);
        referenceSheet.getCell(`A${HEADER_2_HEIGHT + referenceBodyRowsCount}`).value = ` ${key}`;
        referenceSheet.getCell(`A${HEADER_2_HEIGHT + referenceBodyRowsCount}`).style = {
            font: { name: "Arial", size: 11 },
            alignment: { vertical: "middle" },
            fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: SECTION_COLORS[key].headColor },
            },
        };
        values.forEach(value => {
            referenceBodyRowsCount += 1;
            referenceSheet.getCell(`A${HEADER_2_HEIGHT + referenceBodyRowsCount}`).value = value.id;
            referenceSheet.getCell(`B${HEADER_2_HEIGHT + referenceBodyRowsCount}`).value = `  ${value.title}`;
            referenceSheet.getCell(`C${HEADER_2_HEIGHT + referenceBodyRowsCount}`).value = value.unit;
            referenceSheet.getCell(`D${HEADER_2_HEIGHT + referenceBodyRowsCount}`).value = {
                richText: [
                    {
                        font: { name: "Arial", size: 2 },
                        text: "\n",
                    },
                    {
                        font: { name: "Arial", size: 10 },
                        text: value.description,
                    },
                    {
                        font: { name: "Arial", size: 2 },
                        text: "\n",
                    },
                ],
            };
            referenceSheet.getRow(HEADER_2_HEIGHT + referenceBodyRowsCount).eachCell((cell, cellIndex) => {
                cell.style = {
                    font: cellIndex < 4 ? {
                        name: "Arial",
                        size: 10,
                    } : undefined,
                    alignment: {
                        horizontal: cellIndex === 1 || cellIndex === 3 ? "center" : "left",
                        vertical: "middle",
                        wrapText: true,
                    },
                    fill: cellIndex > 2 ? {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: SECTION_COLORS[key].bodyColor },
                    } : undefined,
                    border: {
                        right: { style: "thin", color: { argb: "d4d4d4" } },
                        left: { style: "thin", color: { argb: "d4d4d4" } },
                        top: { style: "thin", color: { argb: "d4d4d4" } },
                        bottom: { style: "thin", color: { argb: "d4d4d4" } },
                    },
                };
            });
        });
    });
    referenceBodyRowsCount += 1;
    referenceSheet.getRow(HEADER_2_HEIGHT + referenceBodyRowsCount).height = 7.5;
    referenceSheet.mergeCells(`A${HEADER_2_HEIGHT + referenceBodyRowsCount}:D${HEADER_2_HEIGHT + referenceBodyRowsCount}`);
    referenceBodyRowsCount += 1;
    const referenceFooterLineRowNum = HEADER_2_HEIGHT + referenceBodyRowsCount;
    const referenceFooterLineRow = referenceSheet.getRow(referenceFooterLineRowNum);
    referenceFooterLineRow.height = 20;
    referenceSheet.mergeCells(`A${referenceFooterLineRowNum}:D${referenceFooterLineRowNum}`);
    referenceSheet.addImage(lineImageId, {
        tl: { col: 0, row: referenceFooterLineRowNum - 1 },
        ext: { width: 350, height: 28 },
    });
    referenceBodyRowsCount += 1;
    const referenceFooterTextRowNum = HEADER_2_HEIGHT + referenceBodyRowsCount;
    const referenceFooterTextRow = referenceSheet.getRow(referenceFooterTextRowNum);
    referenceFooterTextRow.height = 30;
    referenceSheet.mergeCells(`A${referenceFooterTextRowNum}:D${referenceFooterTextRowNum}`);
    referenceFooterTextRow.getCell(1).value = "Акционерное общество «Федеральная корпорация развития малого и среднего предпринимательства» действует в соответствии с Гражданским кодексом Российской Федерации, федеральным законом от 26.12.1995 No 208-ФЗ «Об акционерных обществах».";
    referenceFooterTextRow.getCell(1).style = {
        font: {
            name: "Arial",
            size: 10,
            color: { argb: "808080" },
        },
        alignment: { vertical: "middle", wrapText: true },
    };
    /* *********************************** */
    /*                                     */
    /*           ВЫГРУЗКА ОТЧЕТА           */
    /*                                     */
    /* *********************************** */
    workbook.xlsx.writeBuffer().then(buffer => {
        downloadExcelFile(fileName, buffer);
    });
};
